import { EMPTY_LIST } from '../../../../constants/common'
import Text from '../../../Text'
import { getCalendarGridWeekNumber } from '../../CalendarGrid.utils'
import { CalendarGridMonthDay } from '../CalendarGridMonthDay'

import * as styles from './CalendarGridMonthWeek.module.css'

function CalendarGridMonthWeek({
  canMoveItems,
  dayLoads,
  days,
  itemsByDay,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  return (
    <>
      <Text isSecondary className={styles.weekNumber}>
        {getCalendarGridWeekNumber(days[0])}
      </Text>
      {days.map(day => (
        <CalendarGridMonthDay
          canMoveItems={canMoveItems}
          day={day}
          dayLoad={dayLoads[day.date]}
          items={itemsByDay[day.date] ?? EMPTY_LIST}
          key={day.date}
          today={today}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      ))}
    </>
  )
}

export default CalendarGridMonthWeek
